import { createRoot } from 'react-dom/client';
import CommonEvents from '../enums/events';
import { FinanceWidgetEvents } from '../enums/FinanceWidgetEvents';
import { customEvent } from './customEvent';
const widgetFacadeFactory = {
    create(config, eventContainer, argRoot) {
        return {
            destroy: () => {
                eventContainer.emit(CommonEvents.DESTROY);
                const root = argRoot ||
                    createRoot(document.getElementById(config.containerId));
                root.unmount();
                eventContainer.removeAllListeners();
            },
            on: (event, callback) => {
                eventContainer.on(event, callback);
            },
            onEvery: (callback) => {
                eventContainer.onEvery(callback);
            },
            updateCarConfig: (code) => customEvent.emit(FinanceWidgetEvents.UPDATE_CAR, code),
        };
    },
};
export default widgetFacadeFactory;
//# sourceMappingURL=widgetFacadeFactory.js.map